const getCertificateIssuedYear = (certificateDate: Date): string => {
  return new Date(certificateDate).getFullYear().toString();
};

const getCertificateIssuedMonth = (certificateDate: Date): string => {
  return (new Date(certificateDate).getMonth() + 1).toString();
};

export const shareWithLinkedin = (
  topicName?: string,
  certificateURL?: string,
  linkedinOrganizationId?: string,
  certificateId?: string,
  certificateDate?: Date,
  certificateExpirationDate?: Date,
): string => {
  const issuedYear = getCertificateIssuedYear(certificateDate);
  const issuedMonth = getCertificateIssuedMonth(certificateDate);
  const expirationYear = getCertificateIssuedYear(certificateExpirationDate);
  const expirationMonth = getCertificateIssuedMonth(certificateExpirationDate);

  const url = new URL('https://www.linkedin.com/profile/add');
  url.searchParams.append('startTask', 'CERTIFICATION_NAME');
  url.searchParams.append('name', topicName);
  url.searchParams.append('organizationId', linkedinOrganizationId);
  url.searchParams.append('issueYear', issuedYear);
  url.searchParams.append('issueMonth', issuedMonth);
  url.searchParams.append('expirationYear', expirationYear);
  url.searchParams.append('expirationMonth', expirationMonth);
  url.searchParams.append('certUrl', certificateURL);
  url.searchParams.append('certId', certificateId);

  return url.href;
};
